// src/store/slices/crystalsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PositionsApi from '../../api/PositionsApi';
import CrystalsApi   from '../../api/CrystalsApi';

const BASE_URL = 'https://api.duotetra.quest/uploads/gems/';

export const fetchCrystals = createAsyncThunk(
    'crystals/fetchCrystals',
    async (promoType = 'onlyCrystals', thunkAPI) => {
        const data = await PositionsApi.getPositionSettingsByPromoType(promoType);
        console.log(data)
        const sorted = data.sort((a, b) => b.number - a.number);
        const entries = await Promise.all(sorted.map(async item => {
            const gem = await CrystalsApi.getGemById(item.gemId);
            return [item.gemId, BASE_URL + gem.frontImage];
        }));
        const icons = Object.fromEntries(entries);
        return { crystals: sorted, icons };
    }
);

const crystalsSlice = createSlice({
    name: 'crystals',
    initialState: {
        items: [],
        icons: {},
        selectedId: null,   // ← здесь
        loading: false,
        error: null,
    },
    reducers: {
        setSelectedId(state, action) {
            state.selectedId = action.payload;
        },
        clearCrystals(state) {
            state.items = [];
            state.icons = {};
            state.selectedId = null;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCrystals.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCrystals.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.items = payload.crystals;
                state.icons = payload.icons;
                // Keep selection only if it still exists; never auto-pick a default here
                // (forms handle create defaults; auto-last caused edit race → 3-cat/200).
                const selectedExists = payload.crystals.some(c => c.id === state.selectedId);
                if (state.selectedId && !selectedExists) {
                    state.selectedId = null;
                }
            })
            .addCase(fetchCrystals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export const { setSelectedId, clearCrystals } = crystalsSlice.actions;
export default crystalsSlice.reducer;
